import * as React from "react";
import { connect } from "react-redux";

import Country from "../../screens/Settings/Country";
import {
  fetchCountries,
  AddCountry,
  DeleteCountry,
  EditCountry,
  countrySelectedPage,
} from "./action";
class CountryContainer extends React.Component<Props, State> {
  render() {
    return (
      <Country
        fetchCountries={this.props.fetchCountries}
        AddCountry={this.props.AddCountry}
        CountryList={this.props.CountryList}
        DeleteCountry={this.props.DeleteCountry}
        EditCountry={this.props.EditCountry}
        CountryCount={this.props.CountryCount}
        countrySelectedPage={this.props.countrySelectedPage}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchCountries: () => {
      dispatch(fetchCountries());
    },
    AddCountry: (value) => {
      dispatch(AddCountry(value));
    },
    DeleteCountry: (value) => {
      dispatch(DeleteCountry(value));
    },
    EditCountry: (value) => {
      dispatch(EditCountry(value));
    },
    countrySelectedPage: (value) => {
      dispatch(countrySelectedPage(value));
    },
  };
}
const mapStateToProps = (state) => {
  return {
    CountryList: state.CountryReducer.CountryList,
    CountryCount: state.CountryReducer.CountryCount,
  };
};

export default connect(mapStateToProps, bindAction)(CountryContainer);
